import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useMutation } from '@tanstack/vue-query'

export const useUpdateAcceptStatus = () => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()

  const mutation = useMutation({
    mutationFn: (data: any) => {
      return http.file(`/inventory/objects/${data.object_id}/workflow`, data)
    },
  })

  const update = async (data: any) => {
    try {
      await mutation.mutateAsync(data)

      addSuccess(trs('itf.updated'))
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    update,
  }
}
